export { default as TabHeaderAction } from './Action.tab';
export { default as TabHeaderCancel } from './Cancel.tab';
export { default as TabHeaderCompany } from './Company.tab';
export { default as TabHeaderComplaint } from './Complaint.tab';
